import { Channel, chatService } from 'services/chat';
import useSWR from 'swr';

export function useDefaultChannels() {
	const {
		data: channels,
		error,
		isLoading,
		isValidating,
		mutate: mutateDefaultChannels,
	} = useSWR<Channel[]>(
		'default-channels',
		async () => {
			try {
				const result = await chatService.getDefaultChannels();
				return result || [];
			} catch (error) {
				console.error('Error fetching default channels:', error);
				throw error;
			}
		},
		{
			revalidateOnFocus: true,
			revalidateIfStale: true,
			dedupingInterval: 2000,
			shouldRetryOnError: true,
			errorRetryCount: 3,
		}
	);

	return {
		channels: channels || [],
		error,
		isLoading,
		isValidating,
		mutateDefaultChannels,
	};
}
